/**
 * @desc commonMessage
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(a: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseCity/commonMessage/${a}`, {
      method: "GET",

      ...options,
    }),
  );
}
